


















import {Prop, Watch} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';
import {Stored} from 'vue-stored-prop-decorator';
import {Fournisseur} from "@/models";

import storeCommande, {CommandeFilter} from '@/stores/modules/commande';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import TableCell from '@/components/Paginate/TableCell.vue';

@Component({
	components: {
		CrudList,
		TableHead,
		TableCell,
	}
})
export default class CrudCommandeList extends Vue {

	@Prop({type: Boolean, default: true  }) public paginate!: boolean;
	@Prop({type: Boolean, default: false }) public dense!   : boolean;

	storeCommande = storeCommande;

	public mounted(): void {
		storeCommande.dispatch('getCommandes');
	}

	private headers = [
		{ text: 'Detail commande', value: 'concatAll' },
		{ text: 'Actions', value: 'action' },
	];
}
